var map = {
	"./investors/500.png": 1258,
	"./investors/byfounders.png": 1259,
	"./investors/inbox-capital.png": 1260,
	"./investors/inventure.png": 1261,
	"./investors/kernel-capital.png": 1262,
	"./investors/northzone.png": 1263,
	"./investors/pressed-ventures.png": 1264,
	"./investors/seed-capital.png": 1265,
	"./investors/thefactory.png": 1266,
	"./investors/vf-debt.svg": 1267,
	"./investors/vf-venture-debt.png": 1268,
	"./startups/dk/donkey.png": 1269,
	"./startups/dk/falcon.png": 1270,
	"./startups/dk/gomore.png": 1271,
	"./startups/dk/pleo.png": 1272,
	"./startups/dk/pleo_old.png": 1273,
	"./startups/dk/tedx.png": 1274,
	"./startups/dk/templafy.png": 1275,
	"./startups/dk/templafy_old.png": 1276,
	"./startups/dk/trustpilot.png": 1277,
	"./startups/dk/voi.png": 1278,
	"./startups/dk/voi_old.png": 1279,
	"./startups/dk/wolt.png": 1280,
	"./startups/fi/brella.png": 1281,
	"./startups/fi/grib.png": 1282,
	"./startups/fi/kaiku.png": 1283,
	"./startups/fi/kodit.png": 1284,
	"./startups/fi/singa.png": 1285,
	"./startups/fi/smartly.png": 1286,
	"./startups/fi/vainu.png": 1287,
	"./startups/fi/wolt.png": 1288,
	"./startups/fi/zadaa.png": 1289,
	"./startups/ni/airpos.png": 1290,
	"./startups/ni/brainwavebank.png": 1291,
	"./startups/ni/bsecur.png": 1292,
	"./startups/ni/catalyst.png": 1293,
	"./startups/ni/datactics.png": 1294,
	"./startups/ni/displaynote.png": 1295,
	"./startups/ni/hug.png": 1296,
	"./startups/ni/saltdna.png": 1297,
	"./startups/ni/sensum.png": 1298,
	"./startups/ni/slice.png": 1299,
	"./startups/no/aprilla.png": 1300,
	"./startups/no/chooose.png": 1301,
	"./startups/no/huddly.png": 1302,
	"./startups/no/iris.png": 1303,
	"./startups/no/kahoot.png": 1304,
	"./startups/no/spacemaker.png": 1305,
	"./startups/no/tidal.png": 1306,
	"./startups/no/tryb.png": 1307,
	"./startups/no/unacast.png": 1308,
	"./startups/no/vibbio.png": 1309,
	"./startups/se/anyfin.png": 1310,
	"./startups/se/appearin.png": 1311,
	"./startups/se/fishbrain.png": 1312,
	"./startups/se/forza.png": 1313,
	"./startups/se/hedvig.png": 1314,
	"./startups/se/karma.png": 1315,
	"./startups/se/mindoktor.png": 1316,
	"./startups/se/tink.png": 1317,
	"./startups/se/truecaller.png": 1318,
	"./startups/se/wint.png": 1319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1257;